import { render, staticRenderFns } from "./MenuRecordPermissions.vue?vue&type=template&id=f2171226"
import script from "./MenuRecordPermissions.vue?vue&type=script&lang=js"
export * from "./MenuRecordPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports